import React, { FC, useState } from 'react';
import { scaleOP } from '@components/frame';
import { fontOP } from '@styles/fonts';
import ColorWrapper from '@styles/colors';
import { ColorFunction } from '@styles/colors/types';
import OperatorPanelSettingsWrapper from '@components/operatorPanel/components/OperatorPanelSettings/components/OperatorPanelSettingsWrapper';
import i18n from 'i18n-js';
import { Text, View } from 'react-native';
import Svg from '@styles/icons/svg';
import { useRoute } from '@react-navigation/native';
import { useSelector } from 'react-redux';
import { selectSelectedItem } from '@reducers/machines';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import NcFileContent from '@components/common/NCFile';
import { useManageHomePageButtonsPress } from '@components/operatorPanel/hooks/useManageHomePageButtonsPress';
import { navigateBack, parseRouteParamAsNumber } from '@helpers';

interface OperatorPanelViewNCFileProps {
  C: ColorFunction;
  scale?: ScaleFunction;
  font?: typeof fontOP;
}

const OperatorPanelViewNCFile: FC<OperatorPanelViewNCFileProps> = ({ C, scale = scaleOP, font = fontOP }) => {
  const headerTextStylesConfig = {
    color: 'Label/Light/Primary',
    fontType: 'Headline',
  } as const;

  const route = useRoute();
  const selectedMachine = useSelector(selectSelectedItem);
  const ncFile = route?.params?.ncFileName;
  const ncFileId = parseRouteParamAsNumber(route?.params?.ncFileId);

  const [isNcFileContentAvailable, setIsNcFileContentAvailable] = useState<boolean>(false);

  const onDoneModifyNCFileType = () => {
    setTimeout(() => {
      navigateBack('OperatorPanel');
    }, 500)
  }

  const { onModifyNCFileTypePress } = useManageHomePageButtonsPress({
    CC: C,
    ncFileId,
    ncFileName: ncFile,
    font,
    scale,
    isNcFileContentAvailable,
    onActionDone: onDoneModifyNCFileType,
  });

  return (
    <OperatorPanelSettingsWrapper.Root C={C} scale={scale} font={font}>
      <OperatorPanelSettingsWrapper.Header>
        <OperatorPanelSettingsWrapper.HeaderLeftSide>
          <Svg icon="machineIgnoredSmall" width={scale(15)} height={scale(12)} color="Label/Dark/Secondary" />
          <Text style={[font[headerTextStylesConfig.fontType], { color: C(headerTextStylesConfig.color) }]}>{i18n.t('Ignored NC File')}</Text>
        </OperatorPanelSettingsWrapper.HeaderLeftSide>
        <OperatorPanelSettingsWrapper.Title text={ncFile} fontType={headerTextStylesConfig.fontType} color={headerTextStylesConfig.color} />
        <OperatorPanelSettingsWrapper.HeaderRightSide containerStyles={{ gap: scale(20) }}>
          <OperatorPanelSettingsWrapper.ActionButton onPress={onModifyNCFileTypePress}>
            {i18n.t('Modify NC File Type')}
          </OperatorPanelSettingsWrapper.ActionButton>
          <OperatorPanelSettingsWrapper.CloseButton />
        </OperatorPanelSettingsWrapper.HeaderRightSide>
      </OperatorPanelSettingsWrapper.Header>

      <OperatorPanelSettingsWrapper.Content>
        <View style={{ paddingHorizontal: scale(24), marginTop: scale(64), flex: 1, width: '100%' }}>
          <NcFileContent
            {...{
              selectedItem: selectedMachine,
              C,
              font,
              scale,
              backgroundColor: C('Background/Light/Field on Panel'),
              ncFileId,
              ncFileName: ncFile,
              isOperatorPanel: true,
              singleColor: true,
              ncFileTextColor: C('Label/Light/Secondary'),
              isPreview: false,
              setIsNcFileContentAvailable: setIsNcFileContentAvailable,
              containerPaddingBottom: 0,
            }}
          />
        </View>
      </OperatorPanelSettingsWrapper.Content>
    </OperatorPanelSettingsWrapper.Root>
  );
};

export default ColorWrapper(OperatorPanelViewNCFile);
